import React, {useRef, useState} from "react";
import ReactECharts from 'echarts-for-react';
import { isMobileView, chartLegendIcon, roundOfToZero, getDOMTextWidth } from "../../utils/Reusables";
import { maxHeight } from "@mui/system";

export default function FunnelChart(props) {
  const { resultSet, COLORS_SERIES, handleCategoryData, dateFieldFormat, columnTitle, legendPosition, isLegendVisible, pivotConfig, columnDisplayName, settings, timeDimensionDateFormat, reportIn = null, h = null, hasFilters = null, hasLinkedReports = null, comparisonChartType } = props;
  
  // let isLegendPaged = isMobileView() ? isLegendVisible && settings?.mobile?.legendPagination : isLegendVisible && settings?.mobile?.legendPagination;
  // let isDashboardReportNonPaginated = (reportIn === "dashboard" && !isLegendPaged  &&  (legendPosition === 'top' || legendPosition === 'bottom'));
  let isDashboardReportNonPaginated = (reportIn === "dashboard");
  /* 224 - card padding, header height, filter height, margin above chart; 54 - filter height, linked reports - 64, canvas margin - 16 */
  let hasLinkedReportsSpacing = hasLinkedReports ? 0 : 64;
  let hasFiltersSpacing = (hasFilters && !isDashboardReportNonPaginated) ? 0: 54;
  let comparisonChartSpacing = comparisonChartType ? 20 : 0;
  let cardSpacing = isDashboardReportNonPaginated ? (224 - hasFiltersSpacing - hasLinkedReportsSpacing) : 0;
  const defaultHeight = (reportIn === "dashboard" && isDashboardReportNonPaginated) ? ((h * 10) + ((h-1) * 20) - cardSpacing - comparisonChartSpacing) : 300;

  const [chartHeight, setChartHeight] = React.useState(defaultHeight);
  const [echartRef, setEchartRef] = React.useState(null);
  const [echartInstance, setEchartInstance] = React.useState(null);

  const chartParentRef = useRef(null);
  const [legendHeight, setLegendHeight] = useState(30);
  const [seriesData, setSeriesData] = React.useState([]);
  const [legendData, setLegendData] = React.useState([]);

 React.useEffect(() => {
  const result = handleCategoryData(resultSet, dateFieldFormat, pivotConfig,timeDimensionDateFormat)
  const series = resultSet.series(pivotConfig).map((s, index) => ({
    name: handleChartLabel(columnTitle, columnDisplayName, s),
    type: 'funnel',
    width: '50%',
    left: 'center',
    height: (legendPosition === 'top' || legendPosition === 'bottom') ? ((chartHeight - legendHeight) + 'px') : 'auto',
    avoidLabelOverlap: true,
    gap: 2,
    funnelAlign: 'center',
    data: s.series.map((obj, i) => { return { value: (obj?.value === undefined || obj?.value === null || obj?.value === 'NaN') ? 0 : obj?.value, name: result?.categories[i] || obj.x } }),
    label: {
      show: settings?.web?.showXaxisLabel ?? true,
      position: (legendPosition === 'right') ? 'left' : 'right'
    },
  }));
  let alignmentType = ''
  let alignmentValue = ''

  switch (legendPosition) {
    case 'right':
      alignmentType = 'right'
      alignmentValue = 15
      break;
    case 'bottom':
      alignmentType = 'bottom'
      alignmentValue = 20
      break;
    case 'top':
      alignmentType = 'top'
      alignmentValue = legendHeight
      break;
    case 'left':
      alignmentType = 'left'
      alignmentValue = 'center'
      break;
  }
  let seriesInfo = series?.map((item) => {
    item["top"] = 0;
    item["bottom"] = 0;
    item["left"] = 0;
    item["right"] = 0;
    
    item[alignmentType] = alignmentValue;
    item['left'] = 'center';
    return item;
  })

  setLegendData(result);
  setSeriesData(seriesInfo);
 }, [resultSet, legendPosition, settings, chartHeight, legendHeight, pivotConfig] );

  React.useEffect(() => {
    if(echartRef) {
      setEchartInstance(echartRef.getEchartsInstance());
    } 
  }, [echartRef]);

  React.useEffect(() => {
    handleChartHeight()
  }, [legendHeight, legendPosition, isLegendVisible, settings]);

  React.useEffect(() => {
    handleChartDimensions();
  }, [chartParentRef, isLegendVisible, legendPosition, settings, legendData]);

  const handleChartHeight = () => {
    if(isLegendVisible) {
      if(isMobileView()) {
        if(settings?.mobile?.legendPagination) {
          setChartHeight(300);
        } else {
          if(legendPosition === 'top' || legendPosition === 'bottom'){
            setChartHeight(legendHeight + 270);
          } else {
            setChartHeight(legendHeight + 300);
          }
        }

      } else {

        if( settings?.web?.legendPagination) {
          setChartHeight(300);
        } else {
          if(legendPosition === 'right' || legendPosition === 'left') {
            setChartHeight(300); 
          } else {
            setChartHeight(legendHeight + 270); 
          }
        }

      }
    } else {
      setChartHeight(300);
    }
  }

  const handleChartDimensions = () => {
    if(isLegendVisible) {
      let isLegendPagination = isMobileView() ? settings?.mobile?.legendPagination : settings?.web?.legendPagination
      if(isLegendPagination) {
        setLegendHeight(30);
      } else {
        if(legendPosition === 'top' || legendPosition === 'bottom') {
          let labelLengths = legendData?.categories?.map(label => {
            return getDOMTextWidth(label, '12px sans-serif')
          })
          
          labelLengths = labelLengths?.map(item => item + 47);
          let totalLegendLines = 0;
          let totalLegendLineStringWidth = 0;
          let cardWidth = chartParentRef?.current?.clientWidth - 20; /* left margin */
          (cardWidth && labelLengths?.length) && labelLengths?.forEach((item, i) => {
              totalLegendLineStringWidth += item;
              if(totalLegendLineStringWidth > cardWidth) {
                  totalLegendLines++;
                  totalLegendLineStringWidth = item;
              }
          });
          totalLegendLines++;
          let totalLegendHeight = 30 * totalLegendLines + 30;
          setLegendHeight(totalLegendHeight);
        } else {
          setLegendHeight(0);
        }
        
      }
    } else {
      setLegendHeight(0);
    }
    
  }


const legendWidthForTopBottomPositions = () => {
  var legendValues = legendData?.categories?.filter(n => n);
    let legendLabelsCount;
    if(!isMobileView() && settings?.web?.legendPagination && settings?.web?.maxLegendsCount){
      legendLabelsCount = settings?.web?.maxLegendsCount
    } else if(isMobileView() && settings?.mobile?.legendPagination && settings?.mobile?.maxLegendsCount) {
      legendLabelsCount = settings?.mobile?.maxLegendsCount
    } else {
      return null;
    }
    
    let maxLabelValues = legendValues?.slice(0, legendLabelsCount);
    let labelLengthsWeb = maxLabelValues?.map(label => {
      return getDOMTextWidth(label, '12px sans-serif')
    })
    
    let legendWidth = (labelLengthsWeb.reduce((a, b) => a + b, 0) + (45 * labelLengthsWeb?.length));
    return legendWidth + 55;
}

  let legend = {}
  let legendWidth;
  let isLegendPagination = isMobileView() ? settings?.mobile?.legendPagination : settings?.web?.legendPagination;

  switch (legendPosition) {
    case 'right':
      legend = {
        orient: 'vertical',
        left: 'right',
        top: 0,
        type: 'scroll',
        show: isLegendVisible,
        icon: chartLegendIcon(),
        formatter: function (name) {
          if (name?.length > 12) {
            return name.substring(0, 12) + '...'
          }
          return name;
        },
        itemHeight: 20,
        textStyle: {
            fontSize: 12,
            lineHeight: 20,
        },
      }

      if (settings?.web?.legendPagination && settings?.web?.maxLegendsCount && !isMobileView()) {
        legend.height = Number(settings?.web?.maxLegendsCount) * 30 + 24
      }
      else if (settings?.mobile?.legendPagination && settings?.mobile?.maxLegendsCount && isMobileView()) {
        legend.height = Number(settings?.mobile?.maxLegendsCount) * 30 + 24
      }
      else {
        legend.height = 300;
      }

      break;
    case 'bottom':
      legend = {
        orient: 'horizontal',
        bottom: 0,
        left: '10px',
        itemGap: 10,
        type: isMobileView() ? (settings?.mobile?.legendPagination ? 'scroll' : 'plain') : (settings?.web?.legendPagination ? 'scroll' : 'plain'),
        show: isLegendVisible,
        icon: chartLegendIcon(),
        formatter: null,
        itemHeight: 20,
        textStyle: {
            fontSize: 12,
            lineHeight: 20,
        },
      }

      legendWidth = legendWidthForTopBottomPositions();
      if(legendWidth) {
        legend.width = legendWidth;
      } else {
        delete legend?.width;
      }
      if(isLegendPagination) legend.height = 30;
      break;
    case 'top':
      legend = {
        orient: 'horizontal',
        top: -6,
        left: 'center',
        type: isMobileView() ? (settings?.mobile?.legendPagination ? 'scroll' : 'plain') : (settings?.web?.legendPagination ? 'scroll' : 'plain'),
        show: isLegendVisible,
        icon: chartLegendIcon(),
        formatter: null,
        itemHeight: 20,
        textStyle: {
            fontSize: 12,
            lineHeight: 20,
        },
      }

      legendWidth = legendWidthForTopBottomPositions();
      if(legendWidth) {
        legend.width = legendWidth;
      } else {
        delete legend?.width;
      }
      if(isLegendPagination) legend.height = 30;
      break;
    case 'left':
      legend = {
        orient: 'vertical',
        left: 'left',
        top: 0,
        type: 'scroll',
        show: isLegendVisible,
        icon: chartLegendIcon(),
        formatter: function (name) {
          if (name?.length > 12) {
            return name.substring(0, 12) + '...'
          }
          return name;
        },
        itemHeight: 20,
        textStyle: {
            fontSize: 12,
            lineHeight: 20,
        },
      }

      if (settings?.web?.legendPagination && settings?.web?.maxLegendsCount && !isMobileView()) {
        legend.height = Number(settings?.web?.maxLegendsCount) * 30 + 24
      }
      else if (settings?.mobile?.legendPagination && settings?.mobile?.maxLegendsCount && isMobileView()) {
        legend.height = Number(settings?.mobile?.maxLegendsCount) * 30 + 24
      }
      else {
        legend.height = 300;
      }
      break;
  }


  let options = {
    tooltip: {
      trigger: 'item',
      backgroundColor: 'rgba(0,0,0,0.8)',
      borderWidth: '0',
      textStyle: {
        color: '#ffffff',
        fontWeight: 'bold'
      }
    },
    //height: chartHeight,
    legend,
    series: seriesData,
    color: COLORS_SERIES,
    // grid: {
    //   height: 200
    // }
  };

  //console.log("JJ", chartHeight, legendHeight, options)
  //echartInstance && echartInstance.setOption(options);
  return (
    <div className={'chart-parent'} ref={chartParentRef} style={{marginRight: '10px'}} >
      <ReactECharts 
        style={{
          height: chartHeight + 'px', 
          width: '100%'
        }} 
        option={options} className="funnel_chart" 
        ref={(e) => {setEchartRef(e)}}
        opts={{ renderer: 'svg' }}
      />
    </div>
  )
}

const handleChartLabel = (columnTitle, columnDisplayName, s) => {
  let label;
  if (columnTitle && columnTitle.length && columnTitle[0][s?.key]) {
    label = columnTitle[0][s?.key]
  }
  else if (columnDisplayName && columnDisplayName[s?.key]) {
    label = columnDisplayName[s?.key]
  }
  else if (s?.key && columnDisplayName && Object.keys(columnDisplayName).length) {
    Object.keys(columnDisplayName).forEach(col => {
      if (s?.key.includes(col)) {
        s.key = s?.key.replace(col, columnDisplayName[col]);
        label = s?.key;
      }
      else {
        label = s?.title
      }
    })
  }
  else {
    label = s?.title
  }

  return label;
}


